




























































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import moment from 'moment';
import { Debounced } from '../../utils/debounced';

@Component({
  components: {
    Loading,
  },
})
export default class GoodsList extends Vue {
  private user: any;
  private moment: any = moment;
  private dateFormat: string = 'YYYY-MM-DD';
  private debouncedUse: (...args: any[]) => any =  new Debounced().use(this.pullDataSource, 1000);
  private dataSource: any = [];
  private selectBeforeTime: any = this.moment(new Date()).add(-2, 'days');
  private selectAfterTime: any = this.moment(new Date());
  private searchProductNameAsinJson: any = [];
  private searchProductName: string = '';
  private searchPM: string = '家伟';
  private selectDataJson: any = [];
  private searchAsin: string = '';
  private productNumber: string = '';
  private spinning = false;
  private plainOptions = [1];
  private checkedList = [
    // {
      // checked: false,
      // value: 0, // 最后数据库插入的数量  =  value + list.goodsAmazonDeliverNumber(之前发往的数量)
      // goodsDeliverNumber: list.goodsDeliverNumber, // 本次货物的数量
      // goodsAmazonDeliverNumber: list.goodsAmazonDeliverNumber, // 已经发往amazon的数量,
    // }
  ];
  private indeterminate =  false;
  private checkAll =  false;
  private dataJson: any = [];
  private async mounted() {
    this.user = storage.get('user');
    if (this.user) {
      // this.getData();
      this.getSelectData();
      console.log('please login');
    } else {
      this.$router.push({
        path: '/login',
      });
    }
  }
  private async getSelectData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getSelectTracking';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      that.selectDataJson = res.data.data;
      that.spinning = false;
    });
  }
  private getTrackingAll(args: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      // 根据 productNumber 自动填写 其他确认的数据;
      const url = '/api/getTrackingAll';
      this.axios.post(url, args).then((res) => {
        const data = res.data.data[0];
        that.searchProductName = data.productName;  // 产品名称
        that.searchPM  = data.pmName; // PM
        that.searchAsin  = data.asin; // asin
        that.productNumber  = data.productNumber; // 产品number
        resolve();
      });
    });
  }
  private async pullDataSource(searchText: string) {
    const data: any = await this.getDataSource(searchText);
    const arr: any = [];
    if (data.length > 0) {
      data.forEach((element: any, index: number) => {
        arr.push(element.productName);
      });
      this.dataSource = arr;
    }
  }
  private getDataSource(Keyword: string) {
    return new Promise((resolve, reject) => {
      this.spinning = true;
      const that = this;
      const url = '/api/getPmInfoLike';
      const args = {
        pmName: this.searchPM,
        Keyword,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          console.log(res.data.data);
          resolve(res.data.data);
          // that.dataSource = res.data.data;
          this.spinning = false;
        }
      });
    });
  }
  private async handleChange(value: string, type: string, asinType: string) {
    // asinType  1 empty  2 asin
    const that = this;
    if ( type === 'pmName' ) {
      that.dataSource.splice(0, that.dataSource.length);
      const url = '/api/getPMTrackingProAsin';
      const args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          if (asinType === 'empty') {
            that.searchProductNameAsinJson = res.data.data[0];
            that.searchProductNameAsinJson.unshift({
              productName: 'ALL',
              asin: '',
            });
            that.searchProductName = '';
            that.searchAsin = '';
          } else if ( asinType === 'asin' ) {
            that.searchProductNameAsinJson = res.data.data[0];
            that.searchProductNameAsinJson.unshift({
              productName: 'ALL',
              asin: '',
            });
          }
        }
      });
    } else if ( type === 'productName' ) {
      const args = {
        productName: value,
      };
      await this.getTrackingAll(args);
      this.searchProductNameAsinJson.forEach( (element: any) => {
        if (element.productName === value) {
          this.searchAsin = element.asin;
        }
      });
    }
  }
  private async onSearch(searchText: string) {
    this.debouncedUse(searchText);
  }
  private mergeAmazon() {
    let checkedList = JSON.parse(JSON.stringify(this.checkedList));
    // 删除 未选中的数据
    checkedList = this.pushArrayItem(checkedList, 'checked', true);
    if (checkedList.length === 0) {
      this.$message.warning('请选中要发货的数据!!!');
      return false;
    }
    // 选中 产品发货数量不能为0;
    const flag = this.checkKeyValue(checkedList, 'value', 0);
    if (!flag) {
      this.$message.warning('选中产品发货数量不能为0,请检查!!');
      return false;
    }
    // 不能有不同的产品
    const flag1 = this.checkReat(checkedList, 'productNumber');
    // 不能有包材
    const flag2 = this.checkKeyValue(checkedList, 'purchaseType', '包材');
    // 检查asin 是否相同
    if (!flag1 || !flag2) {
      this.$message.warning('选中的asin必须相同,且不能为包材,请检查!!');
      return false;
    }
    // 计算 这次合并后要发送多少
    const mergeNumObj = this.countObj(checkedList);
    // 原来数据组装成后台部分数据
    const arrangeLIst = this.arrangeCheckedList(checkedList);
    // 原来数据组装成后台数据
    const mergeObj = {
      mergeNumObj,
      checkedList: arrangeLIst,
    };
    // 合并为一个 对象,保存在vuex
    this.$store.commit('changeArrangeGoodsInfo', mergeObj);
    // 跳转
    this.$router.push({
      path: '/Tracking',
      query: {
        from: 'ArrangeGoodsList',
      },
    });
  }
  private onPickerChange(date: any, dateString: string) {
    // console.log(date, dateString);
    this.selectBeforeTime = date[0];
    this.selectAfterTime = date[1];
  }
  private arrangeCheckedList(checkedList: any) {
    // 发货数量不能大于当前货物总数!!!'  扣除 非产品也就是包材的库存量
    // 发货数量不能大于当前货物总数!!!'  扣除 非产品也就是包材的库存量 deductionGoods
    const arr: any = [];
    checkedList.forEach((data: any, index: number) => {
      let goodsStatus = 1;
      let goodsAmazonDeliverNumber = data.goodsAmazonDeliverNumber;
      goodsAmazonDeliverNumber += data.value;
      if (goodsAmazonDeliverNumber > data.goodsDeliverNumber) {
        this.$message.warning('发货数量+已发货数量 不能大于 当前货物总数!!!');
        return false;
      } else if (goodsAmazonDeliverNumber === data.goodsDeliverNumber) {
        goodsStatus = 2;
      }
      const obj = {
        id: data.id,
        productNumber: data.productNumber,
        goodsDelivering: data.value,  // 本次 发货的数量
        goodsDeliverNumber: data.goodsDeliverNumber, // 这个快递下工厂一共给的货物数量
        goodsAmazonDeliverNumber, // 本次 + 之前的发货数量
        goodsStatus, // 货物的状态
      };
      arr.push(obj);
    });
    return arr;
  }
  private countObj(checkedList: any) {
    let num = 0;
    let productNumber = '';
    let purchaseType = '';
    checkedList.forEach((list: any, index: number) => {
      if (index === 0) {
        productNumber = list.productNumber;
        purchaseType = list.purchaseType;
      }
      num += list.value;
    });
    const obj = {
      goodsDelivering: num,  // 本次 发货的数量
      productNumber, // 产品编号
      purchaseType, // 产品采购类型
    };
    return obj;
  }
  private pushArrayItem(arr: any, key: string, value: boolean) {
    const brr: any = [];
    arr.forEach((item: any, i: number) => {
      if (item[key] === value) {
        brr.push(item);
      }
    });
    return brr;
  }
  private checkReat(arr: any, key: string) {
    for (let i = 0; i < arr.length - 1; i++) {
      console.log();
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i][key] !== arr[j][key]) {
          console.log('必须是相同的产品编号');
          return false;
        }
      }
    }
    return true;
  }
  private checkKeyValue(arr: any, key: string, value: any) {
    for (const list of arr) {
      if (list[key] === value) {
        return false;
      }
    }
    return true;
  }
  private deduction(type: string, data: any, obj: any) {
    // 发货数量不能大于当前货物总数!!!'  扣除 非产品也就是包材的库存量
    // 发货数量不能大于当前货物总数!!!'  扣除 非产品也就是包材的库存量 deductionGoods
    let goodsStatus = 1;
    let goodsAmazonDeliverNumber = data.goodsAmazonDeliverNumber;
    goodsAmazonDeliverNumber += obj.value;
    if (goodsAmazonDeliverNumber > data.goodsDeliverNumber || obj.value === 0) {
      this.$message.warning('发货数量+已发货数量 不能大于 当前货物总数, 且 不能为0 !!!');
      return false;
    } else if (goodsAmazonDeliverNumber === data.goodsDeliverNumber) {
      goodsStatus = 2;
    }
    const args = {
      id: data.id,
      productNumber: data.productNumber,
      goodsDelivering: obj.value,  // 本次 发货的数量
      goodsDeliverNumber: data.goodsDeliverNumber, // 这个快递下工厂一共给的货物数量
      goodsAmazonDeliverNumber, // 本次 + 之前的发货数量
      goodsStatus, // 货物的状态
    };
    if (type === '包材') {
      // 包材直接扣除数量
      this.deductionGoods(args);
    } else {
      // 产品 和 '产品及包材 走发货系统'
      this.sendAmazon(args);
    }
  }
  private sendAmazon(args: any) {
    const that = this;
    // this.$store.commit({
    //   type: 'changeGoodsInfo',
    //   args:args,
    // });
    this.$store.commit('changeGoodsInfo', args);
    this.$router.push({
      path: '/Tracking',
      query: {
        from: 'GoodsList',
      },
    });
    // this.spinning = true;
    // // 清空数组  112-0006206-7613056
    // const url: string = '/api/changeGoodsData';
    // this.axios.post(url, args).then((res) => {
    //   const dataJson = res.data;
    //   if (dataJson.code === 12) {
    //     that.getData();
    //   } else {
    //     that.spinning = false;
    //   }
    // });
  }
  private deductionGoods(args: any) {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/changeGoodsData';
    this.axios.post(url, args).then((res) => {
      const dataJson = res.data;
      if (dataJson.code === 12) {
        that.getData();
      } else {
        that.spinning = false;
      }
    });
  }
  private onChangeCheckbox(checkedList: any) {
    checkedList.every((list: any) => {
      if (!list.checked) {
        this.checkAll = false;
        this.indeterminate = false;
        return false;
      } else {
        this.checkAll = true;
        return true;
      }
    });
  }
  private onCheckAllChange(e: any) {
    const that = this;
    const checked = e.target.checked;
    this.checkedList.forEach((list, index) => {
      that.$set(that.checkedList[index], 'checked', checked);
      if (!checked) {
        that.$set(that.checkedList[index], 'value', 0);
      }
    });
    Object.assign(this, {
      indeterminate: false,
      checkAll: checked,
    });
  }
  private changeDeatil() {
   this.$router.push({
      path: '/flow/Purchaseing',
    });
  }
  private async getData() {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/getGoodsList';
    const args = {
      searchPM: this.searchPM,
      productNumber: this.productNumber,
      time: [
        this.moment(this.selectBeforeTime).format(this.dateFormat),
        this.moment(this.selectAfterTime).format(this.dateFormat),
      ],
    };
    this.checkedList.splice(0, this.checkedList.length);
    this.axios.post(url, args).then((res) => {
      const data = res.data.data;
      const checkedList: any = [];
      data.forEach((list: any, index: number) => {
        checkedList.push({
          id: list.id,
          masterId: list.masterId,
          asin: list.asin,
          checked: false,
          value: 0, // 最后数据库插入的数量  =  value + list.goodsAmazonDeliverNumber(之前发往的数量)
          goodsDeliverNumber: list.goodsDeliverNumber, // 本次货物的数量
          goodsAmazonDeliverNumber: list.goodsAmazonDeliverNumber, // 已经发往amazon的数量,
          productNumber: list.productNumber, // 产品编号
          purchaseType: list.purchaseType, // 产品采购类型
        });
      });
      Object.assign(this, {
        checkedList,
      });
      this.dataJson = data;
      this.spinning = false;
    });
  }

}
